import AppApi from "./authentication/appApi";
import FilePreviewApi from "./authentication/filePreviewApi";
import GoogleDriveApi from "./authentication/googleDriveApi";
import OrganizationUserApi from "./authentication/organizationUserApi";
import PreviewApi from "./authentication/previewApi";
import ResourceApi from "./authentication/resourceApi";
import StickerApi from "./authentication/stickerApi";
import StickerPackApi from "./authentication/stickerPack";
import UserScreenApi from "./authentication/userScreenApi";
import VersionApi from "./authentication/versionApi";
import CalendarApi from "./calendarApi";
import AuthApi from "./chat/authApi";
import CallingApi from "./chat/callingApi";
import ConversationApi from "./chat/conversationApi";
import DraftMessageApi from "./chat/draftMessageApi";
import LabelApi from "./chat/labelApi";
import MailApi from "./chat/mailApi";
import MemberScheduleApi from "./chat/memberScheduleApi";
import MessageApi from "./chat/messageApi";
import MessageVoteApi from "./chat/messageVoteApi";
import OrganizationApi from "./chat/organizationApi";
import ReactionApi from "./chat/reactionApi";
import UserApi from "./chat/userApi";
import UserChatApi from "./chat/userChatApi";
import UserConversationApi from "./chat/userConversationApi";
import UserMailApi from "./chat/userMailApi";
import WelcomeSlide from "./chat/welcomeSlideApi";
import AlarmApi from "./workManagement/alarmApi";
import AttributeTemplateApi from "./workManagement/attributeTemplateApi";
import CodeApi from "./workManagement/codeApi";
import OrganizationFromWorkManageApi from "./workManagement/organizationFromWorkManageApi";
import ProjectApi from "./workManagement/projectApi";
import ProjectFile from "./workManagement/projectFile";
import ProjectProgressApi from "./workManagement/projectProgressApi";
import TaskActivityApi from "./workManagement/taskActivityApi";
import TaskApi from "./workManagement/taskApi";
import TaskAttributeApi from "./workManagement/taskAttributeApi";
import TaskMemberApi from "./workManagement/taskMemberApi";
import LetterApi from "./chat/letterApi";
import CameraApi from "./calling/cameraApi";

const apiFactory = {
  authApi: new AuthApi(),
  userApi: new UserApi(),
  conversationApi: new ConversationApi(),
  messageApi: new MessageApi(),
  mailApi: new MailApi(),
  letterApi: new LetterApi(),
  userMailApi: new UserMailApi(),
  organizationApi: new OrganizationApi(),
  userConversationApi: new UserConversationApi(),
  labelApi: new LabelApi(),
  resourceApi: new ResourceApi(),
  googleDriveApi: new GoogleDriveApi(),
  callingApi: new CallingApi(),
  cameraApi: new CameraApi(),
  memberScheduleApi: new MemberScheduleApi(),
  //project management api
  calendarApi: new CalendarApi(),
  taskApi: new TaskApi(),
  taskAttributeApi: new TaskAttributeApi(),
  taskMemberApi: new TaskMemberApi(),
  alarmApi: new AlarmApi(),
  codeApi: new CodeApi(),
  projectApi: new ProjectApi(),
  attributeTemplateApi: new AttributeTemplateApi(),
  organizationFromWorkManageApi: new OrganizationFromWorkManageApi(),
  projectProgressApi: new ProjectProgressApi(),
  taskActivityApi: new TaskActivityApi(),
  reactionApi: new ReactionApi(),
  //authentication
  organizationUserApi: new OrganizationUserApi(),
  userScreenApi: new UserScreenApi(),
  previewApi: new PreviewApi(),
  projectFile: new ProjectFile(),
  draftMessageApi: new DraftMessageApi(),
  appApi: new AppApi(),
  versionApi: new VersionApi(),
  messageVoteApi: new MessageVoteApi(),
  userChatApi: new UserChatApi(),
  stickerApi: new StickerApi(),
  stickerPackApi: new StickerPackApi(),
  welcomeSlideApi: new WelcomeSlide(),
  FilePreviewApi: new FilePreviewApi(),
};

export default apiFactory;
